// CAPABILITY: VdoPage text wordmark. "Vdo" in black, "Page" in #d63b1f,
// set in Playfair Display (serif). On dark backgrounds pass vdoColor="#ffffff".
import React from "react";

export default function Wordmark({ className = "", vdoColor = "#000000", pageColor = "#d63b1f" }) {
  return (
    <span
      className={`font-semibold tracking-tight ${className}`}
      style={{ fontFamily: "'Playfair Display', ui-serif, Georgia, 'Times New Roman', serif" }}
    >
      <span style={{ color: vdoColor }}>Vdo</span>
      <span style={{ color: pageColor }}>Page</span>
    </span>
  );
}
